module.exports = __webpack_public_path__ + "img/oog-behandel.a13ab1d2.jpg";